import api from "./utils";

const crawlWebSource = async (data) => {
  return await api
    .post(`/web/crawl/start`, data)
    .then((results) => results.data);
};

const crawlBatchWebSources = async (data) => {
  return await api
    .post(`/web/crawl/start-batch`, data)
    .then((results) => results.data);
};

const killWebTask = async (data) => {
  return await api
    .post(`/web/crawl/stop`, data)
    .then((results) => results.data);
};

const getCrawlTasks = async (data) => {
  return await api.get("/web/crawl/tasks").then((results) => results.data);
};

const getCrawlResults = async (params) => {
  // if (site_id){
  //   return await api.get(`/web/crawl/results?page=${page}&site_id=${site_id}`).then((results) => results.data);
  // }else{
  //   return await api.get(`/web/crawl/results?page=${page}&sort_by=${sort_by}&sort_direction=${sort_direction}&search=${search}`).then((results) => results.data);
  // }
  return await api.get(`/web/crawl/results`, { params }).then((results) => results.data);

};

const deleteDocument = async (data) => {
  console.log("SERVICE DATA", data);
  return await api
    .delete(`/web/crawl/results/${data["_id"]["$oid"]}`)
    .then((results) => results.data);
};

const deleteTask = async (data) => {
  return await api
    .delete(`/web/crawl/tasks/delete/${data.site_id}`)
    .then((results) => results.data);
};

const getAllCrawlResults = async (site_id) => {
  return await api
    .get(`/web/crawl/results/${site_id}`)
    .then((results) => results.data);
};

export {
  crawlWebSource,
  crawlBatchWebSources,
  getCrawlTasks,
  getCrawlResults,
  getAllCrawlResults,
  deleteDocument,
  deleteTask,
  killWebTask,
};
